var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "goods-keyword-search" },
    [
      _c(
        "el-select",
        {
          staticClass: "goods-search-field",
          attrs: {
            value: _vm.value.matchField,
            size: "small",
            "popper-class": _vm.dropdownClass,
            "aria-label": "搜索字段",
          },
          on: { change: _vm.updateField },
        },
        _vm._l(_vm.fields, function (field) {
          return _c("el-option", {
            key: field.value,
            attrs: { label: field.label, value: field.value },
          })
        }),
        1
      ),
      _c("el-input", {
        ref: "keyword",
        staticClass: "goods-search-keyword",
        attrs: {
          value: _vm.value.keyword,
          placeholder: _vm.placeholder,
          size: "small",
          clearable: "",
          "aria-label": "搜索关键词",
        },
        on: {
          input: _vm.updateKeyword,
          clear: function ($event) {
            return _vm.$emit("search")
          },
        },
        nativeOn: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.$emit("search")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }